import { HighlightUtils } from '@coveo/headless';
import { h } from './index-f214f983.js';
import { e as encodeForDomAttribute } from './string-utils-5f5a23a8.js';

const getPartialRecentQueryElement = (value, i18n) => {
    return {
        part: 'recent-query-item',
        query: value,
        key: `recent-${encodeForDomAttribute(value)}`,
        ariaLabel: i18n.t('recent-query-suggestion-label', {
            query: value,
            interpolation: { escapeValue: false },
        }),
    };
};
const getPartialRecentQueryClearElement = (i18n) => {
    return {
        key: 'recent-query-clear',
        ariaLabel: i18n.t('clear-recent-searches', {
            interpolation: { escapeValue: false },
        }),
        part: 'recent-query-title-item suggestion-divider',
        hideIfLast: true,
    };
};
const RecentQueriesContainer = (_, children) => {
    return (h("div", { part: "recent-query-content", class: "flex items-center break-all text-left" }, children));
};
const RecentQueryIcon = ({ icon, }) => {
    return (h("atomic-icon", { part: "recent-query-icon", icon: icon, class: "mr-2 h-4 w-4 shrink-0" }));
};
const RecentQueryText = ({ query, value, }) => {
    if (query === '') {
        return (h("span", { part: "recent-query-text", class: "line-clamp-2 break-all" }, value));
    }
    return (h("span", { part: "recent-query-text", class: "line-clamp-2 break-all", innerHTML: HighlightUtils.highlightString({
            content: value,
            openingDelimiter: '<span part="recent-query-text-highlight" class="font-bold">',
            closingDelimiter: '</span>',
            highlights: [
                {
                    offset: query.length,
                    length: value.length - query.length,
                },
            ],
        }) }));
};
const RecentQueryClear = ({ i18n, }) => {
    return (h("div", { part: "recent-query-title-content", class: "flex w-full justify-between" },
        h("span", { class: "font-bold", part: "recent-query-title" }, i18n.t('recent-searches')),
        h("span", { part: "recent-query-clear" }, i18n.t('clear'))));
};

export { RecentQueryClear as R, getPartialRecentQueryElement as a, RecentQueryText as b, RecentQueryIcon as c, RecentQueriesContainer as d, getPartialRecentQueryClearElement as g };

//# sourceMappingURL=recent-queries-0525a5e0.js.map